'use client';

import { TableOfContents } from '@mantine/core';
import { useEffect } from 'react';

const FancyTableOfContents = ({ showTitle }: { showTitle: boolean }) => {
  useEffect(() => {
    let animationFrameId: number;

    const updateHighlight = () => {
      const activeLink = document.querySelector('[data-active]'); // Mantine sets this attribute
      const highlight = document.getElementById('toc-highlight');

      if (activeLink && highlight) {
        const rect = activeLink.getBoundingClientRect();
        const containerRect = activeLink
          .closest('div')!
          .getBoundingClientRect();

        const titleBuffer = showTitle ? 50 : 0;
        highlight.style.top = `${rect.top - containerRect.top + titleBuffer}px`;
        highlight.style.height = `${rect.height}px`;
      }

      animationFrameId = requestAnimationFrame(updateHighlight);
    };

    updateHighlight(); // Start tracking

    return () => cancelAnimationFrame(animationFrameId);
  }, [showTitle]);

  return (
    <TableOfContents
      variant="light"
      color="var(--mantine-color-neutral-5)"
      radius="sm"
      scrollSpyOptions={{
        selector: '#content h1, #content h2, #content h3',
      }}
      getControlProps={({ active, data }) => ({
        component: 'a',
        href: `#${data.id}`,
        style: {
          color: active
            ? 'var(--mantine-color-primary-4)'
            : 'var(--mantine-color-neutral-9)',
          fontWeight: active ? 'bold' : 'normal',
          textDecoration: 'none',
          display: 'block',
          padding: '4px 0 4px 12px',
          marginBottom: '8px',
          fontSize:
            data.depth === 3
              ? 'var(--mantine-font-size-sm)'
              : 'var(--mantine-font-size-md)',
          transition: 'color 0.2s ease',
        },
        onMouseEnter: (e) => {
          e.currentTarget.style.color = 'var(--mantine-color-primary-6)';
        },
        onMouseLeave: (e) => {
          e.currentTarget.style.color = active
            ? 'var(--mantine-color-primary-6)'
            : 'var(--mantine-color-neutral-9)';
        },
        children: data.value,
      })}
    />
  );
};

export { FancyTableOfContents };
